export { default as LoyaltyQrCodeLoyaltyIdWidget } from './loyalty-qr-code-loyalty-id-widget';
